// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "commons" + "." + "78fad1d760e5dfdd4c7b" + ".css";
};